import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.css'],
    standalone: false
})
export class ChangepasswordComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
